module.exports = __webpack_public_path__ + "img/KMeansCompression.f1042a61.png";